<template>
	<div class="empty">
        <i class="material-icons icon">{{iconEmpty}}</i>
        <strong class="title">{{titleEmpty}}</strong>
        <p class="description">
            <span v-html="descriptionEmpty">
            </span>
        </p>
        <slot></slot>
    </div>
</template>
<script>
	export default{
		props: {
            icon: String,
            title: String,
            description: String,
        },

        computed: {
            iconEmpty: function () {
                return this.icon ? this.icon : 'event_busy';
            },

            titleEmpty: function () {
                return this.title ? this.title : 'No hay registros';
            },

            descriptionEmpty: function () {
                return this.description;
            },
        }
	}
</script>
<style type="text/css" scoped>
    .empty{
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        text-align: center;
        padding: 36px;
        margin: 0 auto;
        position: relative;
        transition: opacity .15s cubic-bezier(0,0,.2,1),-webkit-transform .3s cubic-bezier(0,0,.2,1);
        transition: opacity .15s cubic-bezier(0,0,.2,1),transform .3s cubic-bezier(0,0,.2,1);
        transition: opacity .15s cubic-bezier(0,0,.2,1),transform .3s cubic-bezier(0,0,.2,1),-webkit-transform .3s cubic-bezier(0,0,.2,1);
        will-change: transform,opacity;
    }

    .empty > .icon {
        width: 160px;
        min-width: 160px;
        height: 160px;
        font-size: 160px !important;
        margin: 0;
        color: rgba(0,0,0,0.26);
    }

    .empty > .title {
        font-size: 26px;
        font-weight: 700;
        line-height: 40px;
    }

    .empty > .description {
        margin: 0 0 1em 0;
        font-size: 16px;
        line-height: 24px;
        color: #a1a1ac;
    }

    .empty > .url {
        
    }
</style>